import { styled } from '@material-ui/core';

export const VerticalStack = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));
